// @flow
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { Link } from 'trpc-react-native-ui';
import { trackAnalyticsEvent } from '../../../lib/analytics';
import theme from '../../../theme-config';

import I18n from '../../../lib/i18n';

type PropsType = {
  onSkipPayment?: Function,
};

export default class CardRegistrationIssue extends Component<PropsType> {
  styles = getStyles();
  onSkipPayment = () => {
    if (this.props.onSkipPayment) {
      this.props.onSkipPayment();
      trackAnalyticsEvent('payment_do_it_later');
    }
  };

  render() {
    return (
      <View>
        <Link style={this.styles.link} text={I18n.t('SignUp.Payment.doItLater')} onPress={this.onSkipPayment} />
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    link: {
      color: theme.signUpDarkTextColor,
      fontSize: 16,
      marginTop: 6,
      textDecorationLine: 'underline',
    },
  });
